export default "/fonts/mydevicon.woff?156e48e43986ba424da455be6c3b03cd";